import { inject, Injectable } from '@angular/core';
import { UseCaseGet } from '@shared/helper';
import { map, Observable } from 'rxjs';
import { FooterResponse } from '@entities/domains/footer.entity';
import { FooterModel } from '@wec-shared/organism.footer';
import { FooterRepository } from '@repositories/footer.repository';

@Injectable({
  providedIn: 'root'
})
export class GetFooterUseCase implements UseCaseGet<FooterModel> {
  private readonly footerRepository = inject(FooterRepository);

  execute(): Observable<FooterModel> {
    return this.footerRepository.GetFooter().pipe(map(this.mapResponse.bind(this)));
  }

  mapResponse(res: FooterResponse) {
    const footerSocialMedia = res.data[0].item.footer_social_media[0];
    const footerBrand = res.data[0].item.footer_brand[0];
    const footerMenu = res.data[0].item.footer_menu;
    const footerDownloadApp = res.data[0].item.footer_download_app[0];
    const footerCopyright = res.data[0].item.footer_copyright[0];

    const socialLinks = footerSocialMedia.icons.map((val, i) => ({
      name: i.toString(),
      url: val.link,
      icon: val.image,
      ariaLabel: i.toString()
    }));

    const navSections = footerMenu.map((val) => ({
      id: val.title,
      title: val.title,
      links: val.child_menu.map((child) => ({
        label: child.title,
        url: child.link
      }))
    }));

    const download = {
      title: footerDownloadApp.title,
      appStore: {
        url: footerDownloadApp.icons[1].link,
        image: footerDownloadApp.icons[1].image,
        alt: 'Google Play'
      },
      googlePlay: {
        url: footerDownloadApp.icons[0].link,
        image: footerDownloadApp.icons[0].image,
        alt: 'App Store'
      }
    };

    const bottom = {
      copyright: footerCopyright.title,
      links: footerCopyright.data.map((val) => ({
        label: val.title,
        url: val.link
      }))
    };

    return {
      logo: footerBrand.logo.image,
      logoMobile: footerBrand.logo.image,
      logoAlt: footerBrand.logo.alt,
      description: footerBrand.description,
      socialTitle: footerSocialMedia.title,
      socialLinks: socialLinks,
      navSections: navSections,
      download: download,
      bottom: bottom
    } as FooterModel;
  }
}
